export default __webpack_public_path__ + "static/media/DMSans-MediumItalic.83954429.ttf";